<script>
export default {
  name: 'LanguageButton',
  props: {
    localeName: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template lang="pug">
cta-style(v-show="!disabled")
  launcher-router-link.language-button.tc.white.pa2.flex.items-center.justify-center(:to="{ name: 'languages' }", :class="{'-disabled': disabled}")
    span.db
      icon.icon.w1.fill-white(name="language" style="width: 2rem;")
      span.label.f6.fw6.db.mt1.ttu {{localeName}}
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";
.language-button {
  width: 7rem;
  height: 7rem;
}
</style>
